module.exports = __webpack_public_path__ + "static/media/mosart.125fa171.png";